export const OnlinePaymentSummaryPageTemplate = {
    slots: ['SlbNewPaymentContainerSlot'],
};